<template>
  <div>
    <div class="container main">
      <!-- Image -->
      <div class="box">
        <label class="label">Image</label>

        <div class="image-container">
          <div class="image-scroll-area" v-if="!imageLoadFailed">
            <img
              class="resourceImage"
              :src="resourceImageURL"
              @load="onImageLoaded"
              @error="onImageLoadError"
            />
          </div>

          <p class="image-missing" v-if="imageLoadFailed">[No image]</p>

          <div class="overlay" v-if="!imageIsLoaded && !imageLoadFailed">
            <Spinner />
          </div>
        </div>

        <div class="file">
          <label class="file-label">
            <input
              class="file-input"
              type="file"
              name="resume"
              @change="uploadImage($event.target.files)"
              :disabled="isUploadingImage"
            />
            <span class="file-cta">
              <span class="file-icon">
                <i class="icon-upload" aria-hidden="true"></i>
              </span>
              <span class="file-label">
                Upload image…
              </span>
              <Spinner v-if="isUploadingImage" width="16px" height="16px" />
            </span>
          </label>
        </div>

        <!-- Image upload error -->
        <div class="notification is-danger" v-if="imageUploadError">
          {{ imageUploadError }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/utils/Spinner'

import {
  GET_SELECTED_RESOURCE_ID,
  UPLOAD_DATA,
  SELECT_RESOURCE_WITH_ID
} from '@/modules/resources/resourcesStore'

export default {
  name: 'ImageResourceDetails',
  components: {
    Spinner
  },

  props: {
    resourcesStorePath: {
      type: String,
      required: true
    },

    resourceId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      isUploadingImage: false,
      imageUploadError: null,
      imageUpdateTimestamp: new Date(),
      imageIsLoaded: false,
      imageLoadFailed: false
    }
  },

  mounted() {
    const selectResourceWithIdAction = `${this.resourcesStorePath}/${SELECT_RESOURCE_WITH_ID}`
    this.$store.dispatch(selectResourceWithIdAction, { resourceId: this.resourceId })

    this.resetUI()
  },

  methods: {
    resetUI() {
      this.imageLoadFailed = false
    },

    async uploadImage(files) {
      if (files.length === 0) {
        return
      }

      const dataFile = files[0]
      const uploadImageAction = `${this.resourcesStorePath}/${UPLOAD_DATA}`

      this.isUploadingImage = true
      this.imageUploadError = null
      try {
        await this.$store.dispatch(uploadImageAction, { resourceId: this.resourceId, dataFile })

        // Hack to trigger reload of image
        this.imageUpdateTimestamp = new Date()

        this.imageIsLoaded = false
        this.imageLoadFailed = false
      } catch (error) {
        this.imageUploadError = error || 'Something went wrong.'
      } finally {
        this.isUploadingImage = false
      }
    },

    onImageLoaded() {
      this.imageLoadFailed = false
      this.imageIsLoaded = true
    },

    onImageLoadError() {
      this.imageLoadFailed = true
    }
  },

  computed: {
    selectedResourceId() {
      const getSelectedResourceId = `${this.resourcesStorePath}/${GET_SELECTED_RESOURCE_ID}`
      return this.$store.getters[getSelectedResourceId]
    },

    resourceImageURL() {
      if (!this.resourceId) {
        return null
      }

      return `${process.env.VUE_APP_APIURL}/v1/admin/resources/${this.resourceId}/data?u=${this.imageUpdateTimestamp}`
    }
  },

  watch: {
    selectedResourceId() {
      // TODO: Is this needed?
      this.resetUI()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/style.scss';

.main {
  padding: 1em;
}

.image-container {
  position: relative;

  .image-scroll-area {
    overflow: auto;
  }

  .overlay {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 6px;
    display: flex;
    align-content: center;
    align-items: center;

    background-color: hsla(0, 0, 0, 0.5);
  }
}

.resourceImage {
  width: 1024px;
  height: 1024px;
  max-width: 1024px;
  max-height: 1024px;
  min-width: 1024px;
  min-height: 1024px;
}

.image-missing {
  margin-bottom: 1em;
}

.file {
  .file-label {
    margin-right: 4px;
  }
}

.file.is-primary .file-input[disabled] ~ .file-cta:hover,
.file.is-primary .file-input[disabled] ~ .file-cta.is-hovered,
.file.is-primary .file-input[disabled] ~ .file-cta:focus,
.file.is-primary .file-input[disabled] ~ .file-cta.is-focused,
.file.is-primary .file-input[disabled] ~ .file-cta:active,
.file.is-primary .file-input[disabled] ~ .file-cta.is-active {
  background-color: whitesmoke;
  border-color: whitesmoke;
  color: #7a7a7a;
}
.file-input[disabled] ~ .file-cta,
.file-input[disabled] ~ .file-name {
  background-color: whitesmoke;
  border-color: whitesmoke;
  color: #7a7a7a;
}

.file-input[disabled] ~ .file-cta,
.file-input[disabled] ~ .file-name,
.file-input[disabled] ~ .file-cta .file-label {
  cursor: not-allowed;
}
</style>
